import { defineComponent as _defineComponent } from 'vue'
import { getFormatDate } from "@/utils/formatDates";
import { computed } from "vue";
import ListItemText from "@/components-UI/list/items/ListItemText.vue";

interface Props {
    value: string,
    isShowTime?: boolean,
    isSeconds?: boolean,
    dateFormat?: 'dd.MM.yyyy' | 'dd MMMM yyyy'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemDate',
  props: {
    value: null,
    isShowTime: { type: Boolean },
    isSeconds: { type: Boolean },
    dateFormat: { default: 'dd.MM.yyyy' }
  },
  setup(__props: any) {

const props = __props as { value: string, isShowTime?: boolean, isSeconds?: boolean, dateFormat: 'dd.MM.yyyy' | 'dd MMMM yyyy' }



const getDate = computed(() => {
    if (!props.value) return '';
    return getFormatDate(props.value, props.dateFormat);
});

const getTime = computed(() => {
    const format = props.isSeconds ? 'HH:mm:ss' : 'HH:mm';
    return getFormatDate(props.value, format);
});

return { __sfc: true,props, getDate, getTime, ListItemText }
}

})